// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2YUkn","label":"Completed_label__1Qzhe"};